import { render, staticRenderFns } from "./CampaignPanel.vue?vue&type=template&id=b1f584ea&scoped=true&"
import script from "./CampaignPanel.vue?vue&type=script&lang=js&"
export * from "./CampaignPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1f584ea",
  null
  
)

export default component.exports